module.exports = __webpack_public_path__ + "static/media/meli.bf727843.svg";